export default __webpack_public_path__ + "static/media/grand-master-yang.f3c34d7b.png";